module.exports = __webpack_public_path__ + "img/nav-design-diamondrings.f204ecb.webp";